module.exports = __webpack_public_path__ + "img/boban.70962643.jpg";